(function() {
  const focusSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function initHeader(element) {
    if (!element || element.dataset.jrbBound === 'true') return;
    element.dataset.jrbBound = 'true';

    const toggle = element.querySelector('[data-jrb-mobile-toggle]');
    const nav = element.querySelector('[data-jrb-mobile-nav]');

    if (toggle && nav) {
      toggle.addEventListener('click', function() {
        const isOpen = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
      });
    }
  }

  function initLoginModal(modal) {
    if (!modal || modal.dataset.jrbBound === 'true') return;
    modal.dataset.jrbBound = 'true';

    let lastTrigger = null;
    const panels = Array.from(modal.querySelectorAll('[data-jrb-login-panel]'));
    const tabButtons = Array.from(modal.querySelectorAll('[data-jrb-login-tab]'));
    const closeButtons = modal.querySelectorAll('[data-jrb-login-close]');
    const backdrop = modal.querySelector('[data-jrb-login-backdrop]');

    function setActivePanel(name) {
      tabButtons.forEach((button) => {
        const isActive = button.dataset.jrbLoginTab === name;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', String(isActive));
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.jrbLoginPanel === name;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('jrb-modal-open');
      if (lastTrigger) {
        lastTrigger.focus();
      }
    }

    function openModal(trigger) {
      lastTrigger = trigger || document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('jrb-modal-open');
      const activeField = modal.querySelector('.jrb-login-modal__panel.is-active ' + focusSelector);
      if (activeField) {
        activeField.focus();
      }
    }

    document.querySelectorAll('[data-jrb-login-open]').forEach((button) => {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        const targetPanel = button.dataset.jrbLoginTarget || 'create';
        setActivePanel(targetPanel);
        openModal(button);
      });
    });

    tabButtons.forEach((button) => {
      button.addEventListener('click', function() {
        setActivePanel(button.dataset.jrbLoginTab);
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        closeModal();
      });
    });

    backdrop?.addEventListener('click', closeModal);

    modal.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  }

  function formatDuration(ms) {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
    }

    return [minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
  }

  function initUrgencyBar(bar) {
    if (!bar || bar.dataset.jrbBound === 'true') return;
    bar.dataset.jrbBound = 'true';

    const countdown = bar.querySelector('[data-jrb-urgency-countdown]');
    const progress = bar.querySelector('[data-jrb-urgency-progress]');
    const current = Number(bar.dataset.currentCents || 0);
    const threshold = Number(bar.dataset.thresholdCents || 0);
    const endAt = bar.dataset.endsAt ? Date.parse(bar.dataset.endsAt) : NaN;

    if (progress && threshold > 0) {
      const ratio = Math.max(0, Math.min(100, (current / threshold) * 100));
      progress.style.width = ratio.toFixed(2) + '%';
    }

    if (countdown && !Number.isNaN(endAt)) {
      const updateCountdown = function() {
        const remaining = endAt - Date.now();
        countdown.textContent = remaining > 0 ? formatDuration(remaining) : countdown.dataset.expiredLabel || 'Expired';
      };

      updateCountdown();
      const interval = window.setInterval(function() {
        updateCountdown();
        if (endAt - Date.now() <= 0) {
          window.clearInterval(interval);
        }
      }, 1000);
    }
  }

  function initProductGrid(section) {
    if (!section || section.dataset.jrbBound === 'true') return;
    section.dataset.jrbBound = 'true';

    const tabs = Array.from(section.querySelectorAll('[data-jrb-grid-tab]'));
    const panels = Array.from(section.querySelectorAll('[data-jrb-grid-panel]'));
    if (!tabs.length || !panels.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function activate(name) {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.jrbGridTarget === name;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function() {
        const panel = panels.find((item) => item.dataset.jrbGridPanel === tab.dataset.jrbGridTarget);

        activate(tab.dataset.jrbGridTarget);

        if (panel) {
          panel.scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: 'start'
          });
        }
      });

      tab.addEventListener('keydown', function(event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        const delta = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + delta + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
      });
    });

    activate(tabs[0].dataset.jrbGridTarget);
  }

  function initAll(root) {
    (root.querySelectorAll ? root.querySelectorAll('[data-jrb-header]') : []).forEach(initHeader);
    (root.querySelectorAll ? root.querySelectorAll('[data-jrb-login-modal]') : []).forEach(initLoginModal);
    (root.querySelectorAll ? root.querySelectorAll('[data-jrb-urgency]') : []).forEach(initUrgencyBar);
    (root.querySelectorAll ? root.querySelectorAll('[data-jrb-product-grid]') : []).forEach(initProductGrid);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:select', function(event) {
    initAll(event.target);
  });
})();
